<template>
	<div
		class="rightsidebar"
		:class="{'rightsidebar--open': this.$store.state.app.sidebars.right}"
		v-if="configuration"
	>
		<div @click="toggleRightSidebar" class="puller rightsidebar__puller">
			<span
				class="puller_icon rightsidebar__puller__icon"
				:class="{'rightsidebar__puller__icon--closed': this.$store.state.app.sidebars.right}"
			></span>
			SUMA
		</div>

		<div ref="scrollable" class="rightsidebar__scrollable">
			<div class="rightsidebar__price-total">
				<RightSidebarPartnerSection />
				<div class="rightsidebar__price-total__title">Razem:</div>
				<div class="rightsidebar__price-total__total">
					{{ formatPrice($store.getters['unitConfiguration/totalCostWithDiscountIncluded']) }}
					<span class="rightsidebar__price-total__brutto"> / brutto</span>
				</div>
			</div>
			<div class="rightsidebar__upper-part">
				<div class="rightsidebar__choice">
					<h3>{{ unit.fullName }}</h3>
					<img :src="require('@/assets/pictures/' + unit.image)" />
				</div>

				<div class="rightsidebar__price-elements">
					<ul>
						<li class="rightsidebar__price-elements__row rightsidebar__price-elements__row--bold">
							<div class="rightsidebar__price-elements__row__caption">
								Podstawowe
							</div>
							<div class="rightsidebar__price-elements__row__price">
								{{ formatPrice($store.getters['unitConfiguration/baseCost']) }}
							</div>
						</li>
					</ul>

					<div class="rightsidebar__color">Kolor: {{ selectedColor }}</div>

					<ul v-if="extrasCost > 0">
						<li class="rightsidebar__price-elements__row rightsidebar__price-elements__row--bold">
							<div class="rightsidebar__price-elements__row__caption">
								Opcje dodatkowe
							</div>
							<div class="rightsidebar__price-elements__row__price">
								{{ formatPrice(extrasCost) }}
							</div>
						</li>
						<li
							v-for="(component, index) in extras"
							class="rightsidebar__price-elements__row"
							:key="index"
						>
							<div class="rightsidebar__price-elements__row__caption">
								{{ component[0] }}
							</div>
							<div class="rightsidebar__price-elements__row__price">
								{{ formatPrice(component[1]) }}
							</div>
						</li>
					</ul>
					<ul v-if="discountValue">
						<li class="rightsidebar__price-elements__row rightsidebar__price-elements__row--bold">
							<div class="rightsidebar__price-elements__row__caption">
								Rabat
							</div>
							<div class="rightsidebar__price-elements__row__price">
								{{ formatPrice(discountValue) }}
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {formatPrice} from '../../common/helpers/format-price';
import WindowScrollMixin from '@/mixins/window-scroll';
import RightSidebarPartnerSection from '@/components/RightSidebarPartnerSection';

export default {
	name: 'RightSidebar',
	mixins: [WindowScrollMixin],
	components: {RightSidebarPartnerSection},
	data() {
		return {
			formatPrice,
		};
	},
	computed: {
		configuration() {
			return this.$store.state.unitConfiguration;
		},
		data() {
			return this.$store.getters['unitConfiguration/data'];
		},
		extras() {
			return this.$store.getters['unitConfiguration/extras'];
		},
		extrasCost() {
			return this.$store.getters['unitConfiguration/extrasCost'];
		},
		discountValue() {
			return (
				this.$store.getters['unitConfiguration/totalCost'] -
				this.$store.getters['unitConfiguration/totalCostWithDiscountIncluded']
			);
		},
		unit() {
			return this.data('unit');
		},

		selectedColor() {
			return this.data('color').fullName;
		},
	},
	methods: {
		handleWindowScroll(dy) {
			this.$refs.scrollable.scrollTop = this.$refs.scrollable.scrollTop + dy;
		},
		toggleRightSidebar() {
			const sidebars = {
				right: !this.$store.state.app.sidebars.right,
			};
			// on phones allow only one sidebar open
			if (this.$store.state.app.media === 'phone') sidebars.left = false;

			this.$store.commit('M_SET_APP_STATE', {sidebars});
		},
	},
};
</script>
